// Campus photo for /colleges/university-of-texas-at-austin: CC BY-SA 3.0, by Guðsþegn, from
// Wikimedia Commons (https://commons.wikimedia.org/wiki/File%3AUT_Tower_-_Main_Building.JPG), checked 2026-09-30 by
// scripts/college-photo.mjs (license allowlist, no restrictions, not a logo).
// Resized and self-hosted under public/colleges/university-of-texas-at-austin/; credited under the photo.
const photo = {
    "slug": "university-of-texas-at-austin",
    "alt": "The Main Building and UT Tower seen from the South Mall at the University of Texas at Austin",
    "src": "/colleges/university-of-texas-at-austin/campus-1600.webp",
    "srcSmall": "/colleges/university-of-texas-at-austin/campus-800.webp",
    "srcMid": "/colleges/university-of-texas-at-austin/campus-1200.webp",
    "width": 1600,
    "height": 900,
    "og": "/colleges/university-of-texas-at-austin/og.jpg",
    "title": "UT Tower - Main Building",
    "author": "Guðsþegn",
    "license": "CC BY-SA 3.0",
    "licenseUrl": "https://creativecommons.org/licenses/by-sa/3.0",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File%3AUT_Tower_-_Main_Building.JPG",
    "read": "2026-09-30"
};

export default photo;
